import React from "react";
import Layout from "../layouts/Layout";
import Hero from "../components/blog/Hero";
import RecentArticles from "../components/blog/RecentArticles";

const Blog = () => {
  return (
    <Layout>
      <Hero />
      <RecentArticles />
    </Layout>
  );
};

export default Blog;
